import React, { PropsWithChildren } from 'react';

import { track } from '@betterment/js-runtime';
import { Dialog, VisuallyHidden } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';

import { Content } from './Content';

import { IdempotencyProviderWithFeatureRegistry } from '../../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';

export const AccountRecommendationModal: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Dialog
      onOpenChange={open => {
        if (!open) {
          track('ElementClicked', {
            name: 'Close',
            module: 'AccountRecommendation',
          });
        }
      }}
    >
      {children}
      <Dialog.Content size="large" css={{ p: 'space.400', minWidth: '400px', minHeight: '200px', maxWidth: '800px' }}>
        <VisuallyHidden>
          <Dialog.Title>Account recommendation</Dialog.Title>
          <Dialog.Description>Your account recommendation</Dialog.Description>
        </VisuallyHidden>
        <ErrorBoundary fallbackType="partial" feature="account recommendation" owner="agents">
          <IdempotencyProviderWithFeatureRegistry featureName="createAccountRecommendation">
            <Content />
          </IdempotencyProviderWithFeatureRegistry>
        </ErrorBoundary>
      </Dialog.Content>
    </Dialog>
  );
};
